import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=2e1d8c1b&scoped=true"
import script from "./preview.vue?vue&type=script&lang=js"
export * from "./preview.vue?vue&type=script&lang=js"
import style0 from "./preview.vue?vue&type=style&index=0&id=2e1d8c1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1d8c1b",
  null
  
)

export default component.exports